import { useTranslation as e } from "../../i18n.mjs";
import { Modal as t } from "../../components/modal/index.mjs";
import { FileSelectorLayout as n } from "./file-selector.mjs";
import "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/modules/file-selector/file-selector-modal.tsx
function i({ title: i, opened: a, onClose: o, onSelect: s, ...c }) {
	let { t: l } = e();
	return /* @__PURE__ */ r(n, {
		...c,
		onSelect: s,
		renderContent: (e) => /* @__PURE__ */ r(t, {
			title: i ?? l("file_manager.file_selector.choose_file"),
			opened: a,
			size: "lg",
			onClose: o,
			children: e
		})
	});
}
//#endregion
export { i as FileSelectorModal };
